module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textdetail"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "video_content"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "title_line"
  }, [_c('div', {
    staticClass: "title_line_left"
  }, [_c('div', {
    staticClass: "title_line_left_free"
  }, [_vm._v("免费")]), _vm._v(" "), _c('div', {
    staticClass: "title_line_left_name"
  }, [_vm._v("\n              " + _vm._s(_vm.courseSelfData.title) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "title_line_right"
  }, [_c('share', {
    attrs: {
      "config": {
        url: _vm.url,
        sites: ['qzone', 'qq', 'weibo', 'wechat', 'douban']
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "status_tips"
  }, [_c('div', {
    staticClass: "publish_time"
  }, [_vm._v("发布时间 : " + _vm._s(_vm._f("formatDate")(_vm.time)))]), _vm._v(" "), _c('div', {
    staticClass: "study_count"
  }, [_vm._v("学习人数 : " + _vm._s(_vm.courseSelfData.views_count))])]), _vm._v(" "), _c('div', {
    staticClass: "video_show",
    class: _vm.leftShowFlag == 1 ? 'video_show_html' : 'video_show_video'
  }, [(_vm.leftShowFlag == 1) ? _c('div', {
    staticClass: "video_show_left",
    domProps: {
      "innerHTML": _vm._s(_vm.targetHtml)
    }
  }, [_vm._v("\n            文本文件展示区域\n          ")]) : _c('div', {
    staticClass: "video_show_left"
  }, [_c('video', {
    attrs: {
      "preload": "auto",
      "src": _vm.targetVideo,
      "controls": "controls",
      "height": "100%",
      "width": "100%"
    }
  }, [_vm._v("\n              您的浏览器不支持 video 标签。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "video_show_right"
  }, [_c('el-tabs', {
    staticClass: "eltabs",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "目录",
      "name": "目录"
    }
  }, [_c('div', {
    staticClass: "list_content"
  }, _vm._l((_vm.courseSelfData.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list_item",
      class: item.video.length == 0 ? 'list_item_text' : '',
      on: {
        "click": function($event) {
          return _vm.chapterClickfun(item.video)
        }
      }
    }, [_c('div', {
      staticClass: "list_item_left"
    }, [_c('div', {
      staticClass: "list_item_left_dot   list_item_left_dot_isactive",
      class: index == 0 ?
        'list_item_left_dot_isactive' :
        item.class
    }), _vm._v(" "), _c('div', {
      staticClass: "list_item_left_line"
    })]), _vm._v(" "), _c('div', {
      staticClass: "list_item_right"
    }, [_c('div', {
      staticClass: "list_item_right_title"
    }, [_vm._v("\n                        " + _vm._s(item.title) + " " + _vm._s(item.desc) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "list_item_right_tags"
    }, [_c('div', {
      staticClass: "list_item_right_tags_pic"
    }), _vm._v(" "), (item.video.length != 0) ? _c('div', {
      staticClass: "list_item_right_tags_time"
    }) : _vm._e()])])])
  }), 0)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "简介",
      "name": "简介"
    }
  }, [_c('div', {
    staticClass: "simple_intro"
  }, [_vm._v(_vm._s(_vm.courseSelfData.desc))])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "评论",
      "name": "评论"
    }
  }, [_c('div', {
    staticClass: "simple_intro"
  }, [_vm._v(_vm._s(_vm.courseSelfData.content))])])], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bread_crumb"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "bread_now_dest"
  }, [_vm._v("当前位置：免费课程 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b519c0f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/CourseDetail.vue
// module id = 1527
// module chunks = 0